import React from "react"
import { Helmet } from "react-helmet"
import Navbar from "../components/Navbar"
import "./glayout.css"

const GeneralLayout = props => {
  return (
    <div>
      <Helmet>
        <title>Md Amir - Developer</title>
      </Helmet>
      <div className="star-field">
        <div className="stars stars-sm"></div>
        <div className="stars stars-md"></div>
        <div className="stars stars-lg"></div>
      </div>
      <div>{props.children}</div>
      <Navbar />
    </div>
  )
}

export default GeneralLayout
